import { useContext, useEffect, useState } from "react";
import { api } from "../../services/api";
import SelectSys from "../selectSys";
import { GlobalAlertContext } from "../../contexts/GlobalAlertContext";

export default function SelectEnterprise({ handleSelected, ...props }) {
    const [optionsSelect, setOptionsSelect] = useState([])
    const [optionsSelectInit, setOptionsSelectInit] = useState([])
    const { handleToast, handleLoading } = useContext(GlobalAlertContext);

    useEffect(() => {
        getEntrepise()
    }, [])



    const getEntrepise = async () => {
        handleLoading(true);
        try {
            const { data: list } = await api({ method: 'GET', url: '/source/client' })
            setOptionsSelectInit(list)
            const listSelect = []
            list.map(row => {
                listSelect.push({ label: row.search_name + " / " + row.pes_cpfcnpj, id: row.cre_id, name: row.search_name })
            })
            setOptionsSelect(listSelect)
        } catch (err) {
            handleToast(true, err.response.data.toast, err.response.data.message);
        }
        handleLoading(false);

    }


    return (<SelectSys {...props}
      
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(option) => {
            // Value selected with enter, right from the input
            if (typeof option === 'string') {
                return option;
            }
            // Add "xxx" option created dynamically
            if (option.inputValue) {
                return option.inputValue;
            }
            // Regular option
            return option.label;
        }}
        variant="standard"
        options={optionsSelect}
        sx={{ width: "100%" }}
        onChange={(item, elemento) => {
            if (!!elemento?.id) {
                elemento.name = optionsSelectInit.find(item => item.cre_id == elemento?.id)?.search_name;
            }
            if (elemento) {
                handleSelected(elemento);
            }
        }} />);
}
